import { PayloadAction } from '@reduxjs/toolkit'
import { SagaIterator } from 'redux-saga'
import { all, call, fork, put, takeLatest } from 'redux-saga/effects'
import { GET_ADDS_DATA } from './actionTypes'
import { getAddsRecordedData, getAddsManualData } from './api'
import { addAddsData, errorAddsData } from './addsDataReducer'
import {
  AddsDataEntityType,
  AddsDataType,
  GetAddsDataActionType,
} from './types'
import {
  setManualToAdds,
  setRecordedToAdds,
} from '../../containers/PatientsView/PatientTabs/AddsChartTab/util'
import { PatientRecordedDataType } from '../recordedData/types'
import { ManualDataType } from '../../containers/PatientsView/PatientTabs/AddsChartTab/types'

const additionalData: PatientRecordedDataType[] = [
  {
    patientKey: 'PKk6UeP3xvqcYMVicBO5',
    createTimestamp: '23-02-2025 10:35:00.000',
    mews: 2,
    spo2Score: 1,
    spo2: 94,
    prScore: 0,
    pr: 78,
    respScore: 1,
    resp: 50,
    tempScore: 0,
    temp: 98.6,
    bpScore: 0,
    dia: 75,
    sys: 120,
  },
  {
    patientKey: 'PKk6UeP3xvqcYMVicBO5',
    createTimestamp: '23-02-2025 10:40:00.000',
    mews: 1,
    spo2Score: 0,
    spo2: 97,
    prScore: 0,
    pr: 82,
    respScore: 1,
    resp: 21,
    tempScore: 0,
    temp: 98.8,
    bpScore: 0,
    dia: 72,
    sys: 118,
  },
  {
    patientKey: 'PKk6UeP3xvqcYMVicBO5',
    createTimestamp: '23-02-2025 10:42:00.000',
    mews: 3,
    spo2Score: 1,
    spo2: 93,
    prScore: 1,
    pr: 102,
    respScore: 1,
    resp: 22,
    tempScore: 0,
    temp: 99.1,
    bpScore: 0,
    dia: 78,
    sys: 125,
  },
  {
    patientKey: 'PKk6UeP3xvqcYMVicBO5',
    createTimestamp: '23-02-2025 10:20:00.000',
    mews: 4,
    spo2Score: 2,
    spo2: 91,
    prScore: 1,
    pr: 105,
    respScore: 1,
    resp: 21,
    tempScore: 0,
    temp: 99.3,
    bpScore: 0,
    dia: 80,
    sys: 130,
  },
  {
    patientKey: 'PKk6UeP3xvqcYMVicBO5',
    createTimestamp: '23-02-2025 10:23:00.000',
    mews: 2,
    spo2Score: 0,
    spo2: 96,
    prScore: 1,
    pr: 108,
    respScore: 1,
    resp: 21,
    tempScore: 0,
    temp: 98.9,
    bpScore: 0,
    dia: 76,
    sys: 122,
  },
  {
    patientKey: 'PKk6UeP3xvqcYMVicBO5',
    createTimestamp: '23-02-2025 10:55:00.000',
    mews: 1,
    spo2Score: 0,
    spo2: 98,
    prScore: 0,
    pr: 88,
    respScore: 1,
    resp: 21,
    tempScore: 0,
    temp: 98.7,
    bpScore: 0,
    dia: 74,
    sys: 124,
  },
  {
    patientKey: 'PKk6UeP3xvqcYMVicBO5',
    createTimestamp: '23-02-2025 12:51:00.000',
    mews: 2,
    spo2Score: 0,
    spo2: 97,
    prScore: 1,
    pr: 106,
    respScore: 1,
    resp: 22,
    tempScore: 0,
    temp: 98.8,
    bpScore: 0,
    dia: 75,
    sys: 128,
  },
  {
    patientKey: 'PKk6UeP3xvqcYMVicBO5',
    createTimestamp: '23-02-2025 04:12:00.000',
    mews: 3,
    spo2Score: 1,
    spo2: 94,
    prScore: 1,
    pr: 104,
    respScore: 1,
    resp: 21,
    tempScore: 0,
    temp: 99.0,
    bpScore: 0,
    dia: 78,
    sys: 126,
  },
  {
    patientKey: 'PKk6UeP3xvqcYMVicBO5',
    createTimestamp: '23-02-2025 08:36:00.000',
    mews: 2,
    spo2Score: 0,
    spo2: 96,
    prScore: 1,
    pr: 102,
    respScore: 1,
    resp: 20,
    tempScore: 0,
    temp: 98.9,
    bpScore: 0,
    dia: 76,
    sys: 125,
  },
  {
    patientKey: 'PKk6UeP3xvqcYMVicBO5',
    createTimestamp: '23-02-2025 10:22:00.000',
    mews: 1,
    spo2Score: 0,
    spo2: 98,
    prScore: 0,
    pr: 85,
    respScore: 1,
    resp: 21,
    tempScore: 0,
    temp: 98.6,
    bpScore: 0,
    dia: 74,
    sys: 122,
  },
]

export function* handleAddsData(
  actions: PayloadAction<GetAddsDataActionType>
): SagaIterator<void> {
  try {
    const [responseRecorded, responseManual] = yield all([
      call(
        getAddsRecordedData,
        actions.payload.patientKey,
        actions.payload.startTime,
        actions.payload.endTime
      ),
      call(
        getAddsManualData,
        actions.payload.patientKey,
        actions.payload.startTime,
        actions.payload.endTime
      ),
    ])

    const recordedData: PatientRecordedDataType[] =
      responseRecorded.data.sensorData
    // recordedData.push(...additionalData)
    const modifiedRecordedData: AddsDataType[] =
      recordedData.map(setRecordedToAdds)

    const manualData: ManualDataType[] = responseManual.data.data
    let modifiedManualData: AddsDataType[] = []

    manualData.map((data) => {
      modifiedManualData.push(...setManualToAdds(data))
    })

    const combinedAddsData = [
      ...modifiedRecordedData,
      ...modifiedManualData,
    ].sort((a, b) => a.createTimestampSeconds! - b.createTimestampSeconds!)

    const modifiedData: AddsDataEntityType = {
      key: actions.payload.patientKey,
      addsData: combinedAddsData,
    }

    yield put(addAddsData(modifiedData))
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      (error.message === 'Network Error'
        ? 'Unable to connect to server. Please check your connection and try again.'
        : 'An error occurred while fetching data.')
    yield put(errorAddsData(errorMessage))
  }
}

export function* watcherSaga() {
  yield takeLatest(GET_ADDS_DATA, handleAddsData)
}

export const addsDataSaga = [fork(watcherSaga)]
